import AnnouncementsRoute from './AnnouncementsRoute';

export default {
  name: 'Announcements',
  location: '/announcements',
  component: AnnouncementsRoute,
};
